import { gql } from '@apollo/client';

export const CREATE_EMPLOYEE = gql`
    mutation registerEmployee(
        $venueIds: [ID!]!
        $defaultVenueId: ID!
        $firstName: String!
        $lastName: String!
        $email: String!
        $pin: String
        $password: String!
        $imageUrl: String
        $role: Role
    ) {
        registerEmployee(data: {
            venueIds: $venueIds
            defaultVenueId: $defaultVenueId
            firstName: $firstName
            lastName: $lastName
            email: $email
            pin: $pin
            password: $password
            imageUrl: $imageUrl
            role: $role
        }) {
            id
            pin
            role
            account {
                id
                firstName
                lastName
                email
            }
            venues {
                id
                name
            }
            currentVenue {
                id
                name
            }
        }
    }
`;

export const UPDATE_EMPLOYEE = gql`
    mutation updateEmployee(
        $id: String!
        $venueIds: [ID!]
        $defaultVenueId: ID
        $pin: String
        $email: String
        $password: String
        $firstName: String
        $lastName: String
        $role: Role
    ) {
        updateEmployee(
            id: $id
            data: {
                pin: $pin
                password: $password
                firstName: $firstName
                lastName: $lastName
                email: $email
                role: $role
                venueIds: $venueIds
                defaultVenueId: $defaultVenueId
            }
        ) {
            id
            pin
            role
            account {
                id
                firstName
                lastName
                email
            }
            venues {
                id
                name
            }
            currentVenue {
                id
                name
            }
        }
    }
`;

export const DELETE_EMPLOYEE = gql`
    mutation deleteEmployee($id: String!){
        deleteEmployee(id: $id)
    }
`;
